import styled from 'styled-components';

export const LineChartContainerWrapper = styled.div`
  margin-top: 40px;
`;
export const ItemWrapper = styled.div`
  margin-top: 80px;
`;
